"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es7.object.entries");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _commodityClassificationManage = require("@/api/_homeCloudPlatform/mall/commodityClassificationManage.js");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var formModel = {
  name: '',
  order: undefined,
  icon: ''
};
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  computed: {
    rules: function rules() {
      return {
        name: [{
          required: true,
          message: '请输入分类名称',
          trigger: 'blur'
        }, {
          max: 64,
          message: '输入长度不能超过64位'
        }],
        order: [{
          required: true,
          message: '请输入排序',
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callBack) {
            // -10000 ~ 10000
            if (value * 1 > 9999) {
              callBack('输入的数字不应大于9999');
            } else {
              callBack();
            }
          }
        }]
      };
    },
    dialogTitle: function dialogTitle() {
      var type = '';
      switch (this.dialogType) {
        case 'view':
          type = '检视';
          break;
        case 'add':
          type = '新增';
          break;
        case 'edit':
          type = '编辑';
          break;
      }
      return "".concat(type, "\u5546\u54C1\u5206\u7C7B");
    }
  },
  watch: {
    dialogType: {
      immediate: true,
      handler: function handler(val) {
        this.disabled = val !== 'edit' && val !== 'add';
      }
    }
  },
  data: function data() {
    return {
      formModel: formModel,
      disabled: false,
      tableData: {},
      listLoading: true,
      // 預設排序,依創建時間遞減
      defaultOrdering: '-created_at',
      listQuery: {
        page: 1,
        page_size: 20,
        page_size_before: 20
      },
      dialogVisible: false,
      dialogType: 'view',
      previewImg: {}
    };
  },
  created: function created() {
    this.handleSort();
    this.getList();
  },
  methods: {
    checkPermission: _permission.default,
    getList: function getList(e) {
      var _this = this;
      this.listLoading = true;
      if (e && this.listQuery.page_size_before != e.limit) {
        this.listQuery.page = 1;
        this.listQuery.page_size_before = e.limit;
      }
      (0, _commodityClassificationManage.getGoodscategoryList)(this.handleQuery()).then(function (res) {
        _this.tableData = res || {};
        _this.listLoading = false;
      });
    },
    handleAdd: function handleAdd() {
      var _this2 = this;
      this.formModel = JSON.parse(JSON.stringify(formModel));
      this.handleImg();
      this.dialogType = 'add';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this2.$refs['Form'].clearValidate();
      });
    },
    handleView: function handleView(scope) {
      var _this3 = this;
      this.formModel = Object.assign({}, scope.row);
      this.handleImg();
      this.dialogType = 'view';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    handleEdit: function handleEdit(scope) {
      var _this4 = this;
      this.formModel = Object.assign({}, scope.row); // copy obj
      this.handleImg();
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this4.$refs['Form'].clearValidate();
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this5 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _commodityClassificationManage.deleteGoodscategory)(scope.row.id);
            case 2:
              _this5.getList();
              _this5.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(form) {
        var _this6 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this6.dialogType === 'edit';
                  if (isEdit) {
                    (0, _commodityClassificationManage.updateGoodscategory)(_this6.formModel.id, _this6.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this6.errorHandle(res);
                      }
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else if (_this6.dialogType === 'add') {
                    (0, _commodityClassificationManage.createGoodscategory)(_this6.handleFormData()).then(function (res) {
                      if (res.status_code !== 200) {
                        return _this6.errorHandle(res);
                      }
                      _this6.getList();
                      _this6.dialogVisible = false;
                      _this6.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var _this7 = this;
      var isLt2M = file.size / 1024 / 1024 < 0.1;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 100kb!');
      } else {
        var reader = new FileReader();
        reader.onload = function (e) {
          _this7.previewImg = {
            image: e.target.result,
            file: file
          };
        };
        reader.readAsDataURL(file);
      }
      return isLt2M;
    },
    removeImg: function removeImg() {
      this.previewImg = {};
    },
    handleImg: function handleImg() {
      this.previewImg = {
        image: this.formModel.icon
      };
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetFilter: function resetFilter() {
      this.listQuery = {
        page: 1,
        page_size: this.listQuery.page_size,
        ordering: this.listQuery.ordering
      };
      this.getList();
    },
    handleQuery: function handleQuery() {
      var query = (0, _objectSpread2.default)({}, this.listQuery);
      return query;
    },
    handleFormData: function handleFormData() {
      var formdata = new FormData();
      if (this.previewImg.file) {
        this.formModel.icon = this.previewImg.file;
      }
      if (!this.previewImg.image) {
        this.formModel.icon = '';
      }
      Object.entries(this.formModel).forEach(function (item) {
        formdata.append(item[0], item[1]);
      });
      return formdata;
    },
    handleSort: function handleSort(column) {
      // 初始化處理
      if (!column) {
        this.listQuery.ordering = this.listQuery.ordering || this.defaultOrdering;
        return {
          prop: this.defaultOrdering.indexOf('-') !== -1 ? this.defaultOrdering.split('-')[1] : this.defaultOrdering,
          order: this.defaultOrdering.indexOf('-') !== -1 ? 'descending' : 'ascending'
        };
      }
      // 點擊排序
      else {
        this.listQuery.ordering = column.order ? "".concat(column.order === 'descending' ? '-' : '').concat(column.prop) : this.defaultOrdering;
        this.getList();
      }
    }
  }
};